import ReportRecommendations from './reportRecommendations'
export default ReportRecommendations
